import {patientDirectory} from "./access/patientDirectory";
import {
  useEffect,
  useState
} from "react";

import {
  collection,
  onSnapshot
} from "./access/firestore";

import { db }
  from "./firebase";

import { useClinic }
  from "./context/ClinicContext";

import {
  sendWhatsAppFileVPS
} from "./services/whatsappVPS";

export default function
ForwardFileModal({

  isOpen,

  onClose,

  fileUrl,

  filename,

  mimeType

}) {

  const {
    clinicId,
    clinicData
  } = useClinic();

  const [
    pacientes,
    setPacientes
  ] = useState([]);

  const [
    search,
    setSearch
  ] = useState("");

  const [
    sending,
    setSending
  ] = useState(false);

  const [
    manualPhone,
    setManualPhone
  ] = useState("");

    const [
    conversations,
    setConversations
  ] = useState([]);

  const filteredPatients =
    pacientes.filter(p => {

      const nombre =

        `${p.nombre || ""}
         ${p.apellidos || ""}`

          .toLowerCase();

      return nombre.includes(
        search.toLowerCase()
      );

    });

    async function handleForward(
        patient
        ) {

        try {

            setSending(true);

            const phone =

            patient.whatsapp ||

            patient.telefono;

            if (!phone) {

            alert(
                "Paciente sin WhatsApp"
            );

            return;

            }

            const result =
            await sendWhatsAppFileVPS(

                clinicId,

                phone,

                fileUrl,

                filename,

                clinicData?.nombreClinica || "VexaDent"

            );

            if (result?.success) {

            alert(
                "Documento reenviado"
            );

            onClose();

            } else {

            alert(
                result?.error ||
                "Error enviando archivo"
            );

            }

        } catch(error) {

            console.error(error);

            alert(
            error.message
            );

        } finally {

            setSending(false);

        }

    }

    async function handleManualForward() {

        try {

            if (!manualPhone) {

            alert(
                "Ingresa un número"
            );

            return;

            }

            setSending(true);

            const result =
            await sendWhatsAppFileVPS(

                clinicId,

                manualPhone,

                fileUrl,

                filename,

                clinicData?.nombreClinica || "VexaDent"

            );

            if (result?.success) {

            alert(
                "Documento reenviado"
            );

            onClose();

            }

        } catch(error) {

            console.error(error);

            alert(
            error.message
            );

        } finally {

            setSending(false);

        }

    }

    async function handleConversationForward(
        conversation
        ) {

        try {

            setSending(true);

            const result =
            await sendWhatsAppFileVPS(

                clinicId,

                conversation.whatsapp,

                fileUrl,

                filename,

                clinicData?.nombreClinica || "VexaDent"

            );

            if (result?.success) {

            alert(
                "Documento reenviado"
            );

            onClose();

            }

        } catch(error) {

            console.error(error);

            alert(
            error.message
            );

        } finally {

            setSending(false);

        }

    }

  useEffect(() => {

    if (
        !clinicId ||
        !isOpen
    ) {
        return;
    }

    const unsubscribePatients =
        onSnapshot(

        patientDirectory(db,clinicId),

        snap => {

            setPacientes(

            snap.docs.map(d => ({
                id:d.id,
                ...d.data()
            }))

            );

        }

        );

    const unsubscribeConversations =
        onSnapshot(

        collection(
            db,
            "clinics",
            clinicId,
            "whatsappConversations"
        ),

        snap => {

            setConversations(

            snap.docs.map(d => ({
                id:d.id,
                ...d.data()
            }))

            );

        }

        );

    return () => {

        unsubscribePatients();

        unsubscribeConversations();

    };

    }, [
        clinicId,
        isOpen
        ]);

        if (!isOpen) {
        return null;
        }

        return (

        <div

        onClick={onClose}

        style={{

            position:"fixed",

            inset:0,

            background:
            "rgba(0,0,0,.5)",

            display:"flex",

            justifyContent:"center",

            alignItems:"center",

            zIndex:10001

        }}

    >

      <div

        onClick={(e) => {

            e.stopPropagation();

        }}

        style={{

        width:500,

        maxWidth:"95%",

        background:"#fff",

        borderRadius:16,

        padding:20,

        boxShadow:
          "0 10px 25px rgba(0,0,0,.15)"

      }}>

        <h3 style={{
          marginTop:0
        }}>

          Reenviar archivo

        </h3>

        {sending && (

            <div style={{

                marginBottom:12,

                color:"#16a34a",

                fontWeight:600

            }}>

                Enviando...

            </div>

        )}

        <input

          value={search}

          onChange={e =>

            setSearch(
              e.target.value
            )

          }

          placeholder="Buscar paciente..."

          style={{

            width:"100%",

            padding:10,

            border:
              "1px solid #d1d5db",

            borderRadius:8,

            marginTop:10,

            marginBottom:20

          }}

        />

        <input

            value={manualPhone}

            onChange={e =>
                setManualPhone(
                e.target.value
                )
            }

            placeholder="Número manual (+52...)"

            style={{

                width:"100%",

                padding:10,

                marginBottom:10,

                border:"1px solid #d1d5db",

                borderRadius:8

            }}

            />

            <button

            onClick={
                handleManualForward
            }

            style={{

                width:"100%",

                marginBottom:20,

                padding:10,

                border:"none",

                borderRadius:8,

                background:"#16a34a",

                color:"#fff",

                cursor:"pointer"

            }}

            >

            Enviar a número

        </button>

        <div style={{

          maxHeight:400,

          overflowY:"auto",

          border:
            "1px solid #e5e7eb",

          borderRadius:10

        }}>

          {filteredPatients.length === 0 && (

            <div style={{

              padding:20,

              textAlign:"center",

              color:"#6b7280"

            }}>

              No se encontraron pacientes

            </div>

          )}

          {filteredPatients.map(
            patient => (

              <div

                key={patient.id}

                onClick={() =>
                    handleForward(
                    patient
                    )
                }

                style={{

                    cursor:"pointer",

                    padding:12,

                    borderBottom:
                    "1px solid #eee"

                }}
              >

                <div style={{
                  fontWeight:600
                }}>

                  {patient.nombre}
                  {" "}
                  {patient.apellidos}

                </div>

                <div style={{

                  fontSize:12,

                  color:"#64748b",

                  marginTop:4

                }}>

                  {patient.whatsapp ||
                   patient.telefono ||
                   "Sin teléfono"}

                </div>

              </div>

          ))}

        </div>

        <h4 style={{

            marginTop:20,

            marginBottom:10

            }}>

            Conversaciones

            </h4>

            <div style={{

            maxHeight:200,

            overflowY:"auto",

            border:"1px solid #e5e7eb",

            borderRadius:10

            }}>

            {conversations.map(
                conversation => (

                <div

                    key={conversation.id}

                    onClick={() =>
                    handleConversationForward(
                        conversation
                    )
                    }

                    style={{

                    cursor:"pointer",

                    padding:12,

                    borderBottom:
                        "1px solid #eee"

                    }}

                >

                    <div style={{
                    fontWeight:600
                    }}>

                    {

                        conversation.patientName ||

                        "Prospecto"

                    }

                    </div>

                    <div style={{

                    fontSize:12,

                    color:"#64748b"

                    }}>

                    {conversation.whatsapp}

                    </div>

                </div>

            ))}

        </div>

        <button

          onClick={onClose}

          style={{

            marginTop:20,

            width:"100%",

            padding:12,

            border:"none",

            borderRadius:8,

            background:"#e5e7eb",

            cursor:"pointer",

            fontWeight:600

          }}

        >

          Cerrar

        </button>

      </div>

    </div>

  );

}